import React, { useMemo, useState } from 'react'
import Authenticated from '@/Layouts/Authenticated';
import { Link } from '@inertiajs/inertia-react';
import Swal from 'sweetalert2';
import { Inertia } from '@inertiajs/inertia';
import { hasRole } from '@/helpers/user';
import User from '@/Components/Users/User';

const UsersIndex = ({ auth, store, errors, users, branchOffices }) => {

    console.log({ users, branchOffices })

    // const [usersFiltered, setUsersFiltered] = useState(users);

    const handleDelete = (user) => {
        Swal.fire({
            title: 'Eliminar Usuario',
            html: `Estas seguro que quieres eliminar a ${user.name}`,
            confirmButtonColor: '#ff0000',
            confirmButtonText: 'Eliminar Usuario',
            showCancelButton:true,
        }).then(response => {
            if(response.isConfirmed){
                Inertia.delete(route('users.destroy', {user: user.id}))
            }
        })
    }

    const canShowDeleteButton = (() => {
        if (!hasRole(auth.user, 'super_admin')) {
            return false;
        }

        return true;
    })();

    const canShowEditButton = (() => {
        if (!hasRole(auth.user, 'super_admin')) {
            return false;
        }

        return true;
    })();

    const canShowCreateButton = (() => {
        if (!hasRole(auth.user, 'super_admin')) {
            return false;
        }

        return true;
    })();

    const getUsersByBranchOffice = (branchOfficeId) => {
        return users.filter(user => user.branch_office_id === branchOfficeId);
    }

    return (
        <Authenticated
            store={store}
            auth={auth}
            errors={errors}
            header={<h2 className="font-semibold text-xl text-gray-800 leading-tight flex justify-between">
                <p>Usuarios</p>
                {canShowCreateButton && (
                    <Link href={route('users.create')} className="px-3 py-2 bg-primary text-white rounded text-sm">Agregar nuevo usuario</Link>
                )}
            </h2>}
        >
            <div className="max-w-7xl flex flex-col sm:flex-row py-12 px-3 sm:px-6 lg:px-8 gap-8 mx-auto">
                <div className="sm:w-4/5 flex-col flex gap-3 ">
                    {users.filter(user => !user.branch_office_id && (hasRole(user, 'admin') || hasRole(user, 'super_admin'))).map((user, key) => (
                        <User auth={auth} key={`user-without-branch-office-${key}`} {...user} />
                    ))}

                    {users.filter(user => !user.branch_office_id && user.store === store && (!hasRole(user, 'admin') && !hasRole(user, 'super_admin'))).map((user, key) => (
                        <User auth={auth} key={`user-without-branch-office-${key}`} {...user} />
                    ))}

                    {branchOffices.sort((a, b) => {
                        if (a.is_active && !b.is_active) {
                            return -1;
                        }

                        if (!a.is_active && b.is_active) {
                            return 1;
                        }

                        return 0;
                    }).map(({ id, name, is_active }) => {
                        return (
                            <div>
                                <h3 className="font-bold text-xl mb-3">{name} {is_active ? '' : '(Sucursal cerrada)'}</h3>
                                {getUsersByBranchOffice(id).map((user, key) => (
                                    <User auth={auth} key={key} {...user} />
                                ))}
                            </div>
                        )
                    })}
                    {/* {
                        users && users.map((user, key) => (
                            <User key={key} {...user} />
                        ))
                    } */}
                </div>
            </div>
        </Authenticated>
    )
}

export default UsersIndex
